import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AiSourcingHandlerService } from 'src/app/_services/ai-sourcing-handler.service';
import { AiSourcingService } from 'src/app/_services/ai-sourcing.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { TransactionService } from 'src/app/_services/transaction.service';
declare const clevertap;

@Component({
    selector: 'app-ai-sourcing-landingpage',
    templateUrl: './ai-sourcing-landingpage.component.html',
    styleUrls: ['./ai-sourcing-landingpage.component.scss'],
    standalone: false
})
export class AiSourcingLandingpageComponent implements OnInit {

  showWaitlistBtn: boolean = false;
  showRequestedBtn: boolean = false;
  showCreateProjectBtn: boolean = false;
  showGotoProjectListBtn: boolean = false;
  showAiSourcingStepsCard: boolean = false;

  successMessage: string = '';
  errorMessage: string = '';
  infoMessage: string = '';

  projectListCount: number = 0;
  hoveredStep = 0;

  showLoader: boolean = false;
  activeProjectCount: number = 0;
  autopilotprojectslots: number = 0;
  isAISourcingEnabled: boolean = false;

  constructor(
    private router: Router,
    private activeRoute: ActivatedRoute,
    private aiSourcingService: AiSourcingService,
    private localstorageservice: LocalStorageService,
    private transactionService: TransactionService,
    private aiSourcingHandlerService: AiSourcingHandlerService
  ) {

    // if (!this.activeRoute.snapshot.routeConfig.path.trim()) {
    //   this.getProjectList();
    // }
  }

  ngOnInit() {
    this.isAISourcingEnabled = this.localstorageservice.getItem('autopilotslotaccess') == '1' ? true : false;

    this.getProjectList();
    // this.getCurrentPlanDetails();

  };


  /**
   * Method to fetch all the project count
   */
  getProjectList() {
    this.showLoader = true;
    const start = 0;
    const limit = 10;
    this.aiSourcingService.getProjectList(start, limit).subscribe((response: any) => {
      if (response && response.status == 'success') {
        this.projectListCount = response.totalprojectcount;
         this.activeProjectCount = response.activatedprojectcount;
        this.autopilotprojectslots = response.projectslots;
        this.getCurrentPlanDetails();
      } else {
        this.projectListCount = 0;
        this.getCurrentPlanDetails();
      }
    }, (err) => {
      this.getCurrentPlanDetails();
    })
  };


  /**
   * Methos to fetch user current plan
   */
  getCurrentPlanDetails() {
    // Access refresh for this route is handled by AccessRefreshGuard (canActivate on ai-sourcing,
    // see app-routing.module.ts) - reads the already-loaded signal instead of calling the API again.
    const accessData = this.transactionService.access();
    if (accessData) {
      if (accessData?.hasaisourcingaccess && this.projectListCount > 0) {
       this.router.navigate(['/ai-sourcing/project-list']);
        this.showGotoProjectListBtn = false;
        this.showWaitlistBtn = false;
        this.showRequestedBtn = false;
        this.showCreateProjectBtn = false;
        this.showAiSourcingStepsCard = false;
      } else if (accessData?.hasaisourcingaccess) {
        this.showCreateProjectBtn = true;
        this.showWaitlistBtn = false;
        this.showRequestedBtn = false;
        this.showGotoProjectListBtn = false;
        this.showAiSourcingStepsCard = false;
      } else if (accessData?.hasjoinedaisourcingwaitlist) {
        this.showCreateProjectBtn = false;
        this.showWaitlistBtn = false;
        this.showRequestedBtn = true;
        this.showAiSourcingStepsCard = true;
        this.showGotoProjectListBtn = false;
      } else {
        this.showWaitlistBtn = true;
        this.showRequestedBtn = false;
        this.showCreateProjectBtn = false;
        this.showAiSourcingStepsCard = false;
        this.showGotoProjectListBtn = false;
      }
    } else {
      this.showWaitlistBtn = true;
      this.showRequestedBtn = false;
      this.showCreateProjectBtn = false;
      this.showAiSourcingStepsCard = false;
      this.showGotoProjectListBtn = false;
    }
    this.showLoader = false;
  };

  /**
   * Method to use make request for join waitlist
   */
  joinWaitlist() {
    const data = {
      join: 'yes'
    };

    this.aiSourcingService.joinWaitlistRequested(data).subscribe((res: any) => {
      if (res && res.status == 'success') {
        this.getProjectList();
        this.successMessage = 'Join Waitlist Requested successfully';
        setTimeout(() => { this.successMessage = ''; }, 3000);
      } else {
        this.errorMessage = res.message;
        setTimeout(() => { this.errorMessage = ''; }, 3000);
        this.showWaitlistBtn = true;
        this.showRequestedBtn = false;
        this.showCreateProjectBtn = false;
        this.showAiSourcingStepsCard = false;
        this.showGotoProjectListBtn = false;
      }
    })
  };


  /**
   * Method to redirect on project creation page
   */
  createProject() {
    this.localstorageservice.clearItem('parshedJD');
    this.aiSourcingHandlerService.setDisplayPageEvent('jd-page');
    this.router.navigate(['/ai-sourcing/jd-description']);
    /**
     * Create Project
     */
         const createProjectParams = {
          "User ID": this.localstorageservice.getItem('userdata').userid,
        }
        clevertap.event.push("Autopilot-Create Project",createProjectParams);
  };

  /**
   * Method to redirect project listing page
   */
  goToProjectList() {
    this.router.navigate(['/ai-sourcing/project-list']);
  };

/**
 * Method to redirect on blog page
 */
  learnMoreDetails() {
    window.open('https://fire-crib-a04.notion.site/AI-Sourcing-264d71872fa58000bdb1d36b0f21cb5a');
  };

}
